import Toolbox from "./components/Toolbox";
import "./styles/main.scss";
import BottomSection from "./components/BottomSection";
import TopSection from "./components/TopSection";
import Header from "Dashboard/components/Header";
import { IGetInputsRequestParams } from "../../domain/IGetInputsRequestParams";
import { useCallback, useEffect, useState } from "react";
import { getInputs } from "./input.slice";
import { useAppDispatch } from "hooks/hooks";
import usePagingAndSort,
{ IGetPageRequestParams, IUpdateStateAfterSearchParams } from "hooks/pagingAndSort";
import { useForm } from "react-hook-form";

const Input = () => {
  const dispatch = useAppDispatch();

  const defaultGetInputsRequestParams: IGetInputsRequestParams = {
    searchTerm: undefined,
  };

  const [getInputsRequestParams, setGetInputsRequestParams]
    = useState<IGetInputsRequestParams>(defaultGetInputsRequestParams);

  const limit = 200;

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IGetInputsRequestParams>({
    defaultValues: defaultGetInputsRequestParams
  });

  const getConsumablesInputsWithPaging = useCallback((
    pagingParams: IGetPageRequestParams,
    abortSignal: AbortSignal,
    updateStateAfterFetch: (updateStateParams: IUpdateStateAfterSearchParams) => void
  ): void => {
    dispatch(getInputs({
      getInputsRequestParams,
      pagingParams,
      abortSignal,
      updateStateAfterFetch
    }));
  }, [dispatch, getInputsRequestParams]);

  const { doSortBy, resetAfterSearch, lastElementRef, handleScroll }
    = usePagingAndSort(getConsumablesInputsWithPaging, limit);

  useEffect(() => {
    resetAfterSearch();
  }, [getInputsRequestParams]);

  return (
    <>
      <Header title="Potrošni materijali - ULAZ" />
      <Toolbox
        defaultGetInputsRequestParams={defaultGetInputsRequestParams}
        setGetInputsRequestParams={setGetInputsRequestParams}
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <main id="consumables">
        <TopSection
          lastTableElementRef={lastElementRef}
          handleScroll={handleScroll}
          doSortBy={doSortBy}
        />
        <BottomSection />
      </main>
    </>
  );
};

export default Input;
